import { appConfig } from "./config";

export const DEFAULT_WHATSAPP_MESSAGE = "Hi Joe, ich interessiere mich für eine kostenlose Mathe-Probestunde. Es geht um Klasse __ und aktuell um das Thema __.";

export function normalizeWhatsAppNumber(value: string) {
  const normalized = value.trim().replace(/^00/, "").replace(/\D/g, "");
  return /^\d{8,15}$/.test(normalized) ? normalized : "";
}

export function createWhatsAppUrl(number: string, message = DEFAULT_WHATSAPP_MESSAGE) {
  const normalized = normalizeWhatsAppNumber(number);
  if (!normalized) return undefined;
  return `https://wa.me/${normalized}?text=${encodeURIComponent(message || DEFAULT_WHATSAPP_MESSAGE)}`;
}

export function whatsappUrl() {
  return createWhatsAppUrl(appConfig.whatsappNumber, appConfig.whatsappDefaultMessage);
}
